import api from "@/lib/api";

const VAPID_PUBLIC = process.env.REACT_APP_VAPID_PUBLIC_KEY || "";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function pushStatus() {
  if (!pushSupported()) return { supported: false, subscribed: false, permission: "default" };
  const permission = Notification.permission;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return { supported: true, subscribed: !!sub, permission };
  } catch {
    return { supported: true, subscribed: false, permission };
  }
}

export async function subscribePush() {
  if (!pushSupported()) throw new Error("Push wird auf diesem Gerät nicht unterstützt");
  if (!VAPID_PUBLIC) throw new Error("Server-Push ist nicht konfiguriert");

  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Berechtigung verweigert");

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC),
    });
  }
  const raw = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: raw.endpoint,
    keys: raw.keys,
  });
  return true;
}

export async function unsubscribePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  const raw = sub.toJSON();
  try {
    await api.post("/push/unsubscribe", { endpoint: raw.endpoint, keys: raw.keys });
  } catch { /* ignore */ }
  await sub.unsubscribe();
}
